import en from './messages/en.json';
import es from './messages/es.json';
import ru from './messages/ru.json';
import { createTranslator, type Locale, type Messages } from './core';
const catalogs: Record<Locale, Messages> = { fr: {}, en, es, ru };
export const messagesForLocale = (locale: Locale): Messages => catalogs[locale];
export const getTranslator = (locale: Locale = 'fr') => createTranslator(catalogs[locale]);
